// @flow

import {havePermission} from "./utils"

export default class ExportPermissions {

  canExport(proRole:ProRole = null): boolean {
    return havePermission(
      'export.canExport',
      proRole
    );
  }
}
